import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages (lang) {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
    //  if(locale.toLowerCase()==lang.toLowerCase())
          messages[locale] = locales(key)
    }
  });
  debugger;
  return messages
}

export default new VueI18n({
  locale:  process.env.VUE_APP_I18N_LOCALE || 'en',
  formatFallbackMessages: false,
  messages: loadLocaleMessages("en"),
  missing: (locale, key, vm) => {
    // Return the translation key as the fallback
    return key;
  },
})
